import React from "react";
import { useTranslation } from "react-i18next";

const InstagramFeed = () => {
  const { t } = useTranslation();
  return (
    <section
      data-w-id="56200682-aee9-2b20-4225-6aa2ebc0c692"
      className="section topless"
      style={{ padding: "60px 0 160px 0" }}
    >
      <div className="container">
        <div className="insta-track w-inline-block">
          <div className="track-wrap" style={{ width: "400%" }}>
            <div
              className="track"
              style={{
                background: "none",
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
                width: "100%",
                height: "auto",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              {[...Array(40)].map((_, i) => (
                <div
                  key={i}
                  className="instagram-marquee-text"
                  style={{
                    padding: "0 60px",
                    fontSize: "92px",
                    letterSpacing: "4px",
                    fontWeight: 300,
                    color: "#000",
                    lineHeight: 1,
                  }}
                >
                  {t("home.instagram.marquee")}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="insta-list-wrap w-dyn-list">
          <div role="list" className="insta-list w-dyn-items">
            <div
              style={{
                backgroundImage:
                  "url('/assets/photos/modern_luxury_showit_website_template_designer_88_von_458.jpg')",
              }}
              role="listitem"
              className="insta-item w-dyn-item"
            >
              <div className="insta-link w-inline-block"></div>
            </div>
            <div
              style={{
                backgroundImage: "url('/assets/photos/agapae-hero.jpg')",
              }}
              role="listitem"
              className="insta-item w-dyn-item"
            >
              <div className="insta-link w-inline-block"></div>
            </div>
            <div
              style={{
                backgroundImage:
                  "url('/assets/photos/venice_luxury_wedding_photographer_1_von_1.jpg')",
              }}
              role="listitem"
              className="insta-item w-dyn-item"
            >
              <div className="insta-link w-inline-block"></div>
            </div>
            <div
              style={{
                backgroundImage:
                  "url('/assets/photos/venice_luxury_wedding_photographer_1_von_1_-3.jpg')",
              }}
              role="listitem"
              className="insta-item w-dyn-item"
            >
              <div className="insta-link w-inline-block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
